<template>
  <div data-testid="unified-account-transactions">
    <NavBar>
      <template #left>
        <IconButton
          type="button"
          aria-label="Fechar"
          icon-name="EF0030"
          @click="handleClick"
        />
      </template>
      <template #right>
        <ShowMoneyToggleButton @click.native="toggleClick" />
      </template>
    </NavBar>
    <main class="main">
      <Balances class="main__balances" />
      <StatementList />
    </main>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { NavBar, IconButton } from '@warrenbrasil/nebraska-web';
import { useDashStore } from '@/modules/common/store/DashModule';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { StatementList } from './components/StatementList';
import { Balances } from './components/Balances';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import * as trackEvents from './track-events';

@Component({
  components: {
    NavBar,
    IconButton,
    FadeTransition,
    StatementList,
    Balances,
    ShowMoneyToggleButton
  }
})
export default class TransactionsView extends Vue {
  private readonly dashModule = useDashStore();

  created() {
    trackEvents.trackTransactionsLoad();
  }

  handleClick() {
    this.goHome();
  }

  toggleClick() {
    trackEvents.trackHideEquityClick();
  }

  goHome() {
    this.$router.push({ name: 'home' });
  }
}
</script>
<style lang="less" scoped>
.main {
  max-width: 1297px;
  margin: auto;
  padding: 0 @size-spacing-x1100 @size-spacing-x1000;

  &__balances {
    margin: @size-spacing-x1100 0 @size-spacing-x1200;
  }
}
</style>
